import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import authReducer from './auth/auth-slice';
import cacheReducer from './cache-slice';
import featureTogglesReducer from './feature-toggles/feature-toggles-slice';
import feedbackReducer from './feedback/feedback-slice';
import leaseAppReducer from './leaseApp/lease-app-slice';
import sequenceReducer from './sequence/sequence-slice';
import { setStore } from './store-registry';

const store = configureStore({
  reducer: combineReducers({
    leaseApp: leaseAppReducer ?? [],
    cache: cacheReducer,
    auth: authReducer,
    sequence: sequenceReducer,
    feedback: feedbackReducer ?? [],
    featureToggles: featureTogglesReducer,
  }),
});

// Register the store so modules that can't import it directly
// (due to circular dependencies) can access it via getStore().
setStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppStore = typeof store;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
